import React from 'react'
import { useTranslation } from 'react-i18next'
import SectionComponent from '../../../../components/utils/SectionComponent'
import "./medicalBillsList.scss"

function MedicalBillsList() {
  const { t } = useTranslation()
  return (
    <div className='container-medical-bills-list'>
      <div className="texts-medical-bills-list">

        <SectionComponent title={t("health.medical_bill_list.medical_bill.title")} text={t("health.medical_bill_list.medical_bill.section_text_1")}>
          <p>{t("health.medical_bill_list.medical_bill.section_text_2")}</p>
        </SectionComponent>

        <SectionComponent title={t("health.medical_bill_list.management_procedures.title")} text={t("health.medical_bill_list.management_procedures.section_text")} />
        <SectionComponent title={t("health.medical_bill_list.pharmacy.title")} text={t("health.medical_bill_list.pharmacy.section_text")} />

        <SectionComponent title={t("health.medical_bill_list.profit.title")} text={t("health.medical_bill_list.profit.section_text_1")} >
          <p>{t("health.medical_bill_list.profit.section_text_2")}</p>
        </SectionComponent>

        <SectionComponent title={t("health.medical_bill_list.glosa.title")} text={t("health.medical_bill_list.glosa.section_text")} />

        <SectionComponent title={t("health.medical_bill_list.contracts.title")} text={t("health.medical_bill_list.contracts.section_text_1")}>
          <p>{t("health.medical_bill_list.contracts.section_text_2")}</p>
        </SectionComponent>
      </div>
    </div>
  )
}

export default MedicalBillsList